export default {
  "import_notification_success_title": "Importación completada",
  "import_notification_failed_title": "Error en la importación",
  "import_notification_error_title": "Error de importación",
  "import_notification_message": "La transacción de tipo {importType} ha finalizado el procesamiento con estado: {status}. Haga clic aquí para más detalles.",
  "import_notification_parse_error": "No se pudo procesar la notificación de importación"
};